import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6.5 7h11","key":"svg-0"}],["path",{"d":"M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1","key":"svg-1"}],["path",{"d":"M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1","key":"svg-2"}]]

const IconHourglassHigh = createReactComponent('outline', 'hourglass-high', 'HourglassHigh', __iconNode);

export default IconHourglassHigh;